import type { PaymentRow } from '../types';

// The AP-raise marker is the only untyped Scheduled row — Final-Settlement
// tranches are also Scheduled but carry a payment_type.
export function isRaiseMarker(payment: PaymentRow): boolean {
  return payment.status === 'Scheduled' && payment.payment_type === null;
}
